import { render, staticRenderFns } from "./trophy-icon.vue?vue&type=template&id=83c49d8c&"
import script from "./trophy-icon.vue?vue&type=script&lang=js&"
export * from "./trophy-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports